import { useEffect, useState } from "react";
import { Alert, Tag } from "antd";
import { useTranslation } from "react-i18next";
import locale from "../../../constants/locale";
import type { Bot } from "../../../models";
import { originRequest } from "../../../services/origins";

type Attribution = { name: string | null; category_name: string | null; ref_code: string | null; color: string | null; outside_active_dates: boolean };

export default function ChatOrigin({ bot, chatId }: { bot: Bot; chatId: string | number }) {
  const { t } = useTranslation();
  const [attribution, setAttribution] = useState<Attribution | null>();
  const [error, setError] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    setAttribution(undefined); setError("");
    originRequest<{ attribution: Attribution | null }>(bot, `/chats/${chatId}`, "GET", {}, controller.signal)
      .then((data) => setAttribution(data.attribution))
      .catch((e) => { if (!controller.signal.aborted) setError(e.message); });
    return () => controller.abort();
  }, [bot.id, bot.key, bot.password, chatId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <Alert type="warning" message={t(locale.chatOriginLoadError)} className="mb-3" />;
  if (attribution === undefined || attribution === null) return null;
  return <div className="box mb-3 p-3">
    <strong>{t(locale.chatOrigin)}: </strong>{attribution.name || t(locale.chatOriginsDirectUnknown)}
    {attribution.category_name && <Tag className="ml-2" color={attribution.color || undefined}>{attribution.category_name}</Tag>}
    {attribution.ref_code && <p className="is-size-7 has-text-grey mt-2">{t(locale.chatOriginsAgentReferenceHelp)} <strong>{attribution.ref_code}</strong></p>}
    {!!attribution.outside_active_dates && <Tag color="orange" className="mt-2">{t(locale.chatOriginsOutsideActiveDates)}</Tag>}
  </div>;
}
